export default "__VITE_ASSET__8548718c__"